import React, { Component } from "react";
import { withRouter } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';

import { CardContent } from "@material-ui/core";

import TitleBar from "../../components/TitleBar";
import TitleBarTitle from "../../components/TitleBarTitle";
import UserForm from "./UserForm";
import UserStore from "../../stores/UserStore";
import moment from 'moment'

class CreateUser extends Component {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(user) {
    if(user.sessionTTL===undefined || user.sessionTTL===''|| user.sessionTTL===null || isNaN(user.sessionTTL)){
      user.sessionTTL = 0
    }

    if (user && user.email && user.email.length) {
      user.email = user.email.toLowerCase();
    }
    if (user.isActive===undefined){
      user.isActive = true;
    }
    user.sessionTTL = user.sessionTTL * 60

    UserStore.create(user, user.password, [], resp => {
      this.props.history.push("/users");
    });
  }

  render() {
    let dates = {}

    dates.createdAt = moment().format('DD-MM-YYYY HH:mm:ss')
    dates.loginAt = 'Never'
    
    return(
      <Grid container spacing={4}>
        <TitleBar>
          <TitleBarTitle title="Users" to="/Users" />
          <TitleBarTitle title="/" />
          <TitleBarTitle title="Create" />
        </TitleBar>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <UserForm
                dates={dates}
                submitLabel="Create user"
                onSubmit={this.onSubmit}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }
}

export default withRouter(CreateUser);
